<template>
  <!-- <router-link to='/home'>Login</router-link> -->
  <div class="login">
    <div class="login-container">
      <div class="username">
        <div class="username-title">用户名：</div>
        <div class="username-input">
          <input class="username-input-title" type="text" v-model="user.name" placeholder="输入用户名"/>
        </div>
      </div>
      <div class="userpassworld">
        <div class="userpassworld-title">密&nbsp;&nbsp;&nbsp;&nbsp;码：</div>
        <div class="userpassworld-input">
          <input class="userpassworld-input-title" type="password" v-model="user.pwd" placeholder="输入密码"/>
        </div>
      </div>
      <div class="userbutton">
        <button class="userbutton-btn" ref="du" @click="denglu">登录</button>
      </div>
      <mt-spinner v-if="proxyDengLu" class="customSpinner" color="gray" :size="45" type="fading-circle"></mt-spinner>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Toast, Spinner } from 'mint-ui'
import { post, fetchUrl } from '@/assets/js/network.js'
Vue.component(Spinner.name, Spinner)
export default {
  name: 'Login',
  data () {
    return {
      user: {name: '', pwd: ''},
      proxyDengLu: false
    }
  },
  methods: {
    denglu () {
      var _this = this
      var myMap = {'userDl': this.user.name, 'userMm': this.user.pwd}
      post(fetchUrl('/api/getUser'), myMap, function (responseCode, message) {
        if (responseCode === 0 && message.length !== 0) {
          const user = JSON.parse(message)
          _this.$store.commit('loginUserChange', user)
          _this.$store.commit('userNameChange', {id: user.userId, name: user.userMc})
          //Toast({message: '登录成功：' + user.userMc, position: 'bottom'})
          _this.$router.replace('/list')
        } else {
          Toast('用户名或者密码错误！')
        }
      })
    },
    wsFunc (e) {
      if (e.data.type !== 'webpackOk') {
        this.$refs.du.disabled = 'disabled'
        this.proxyDengLu = true
        this.$store.commit('loginUserChange', e.data)
        this.$store.commit('userNameChange', {id: e.data.userId, name: e.data.userMc})
        this.$nextTick(function () {
          if (this.$store.state.loginUser) {
            this.user.name = this.$store.state.loginUser.userDl
            this.user.pwd = this.$store.state.loginUser.userMm
            var _this = this
            setTimeout(function () {
              _this.$router.replace('/list')
            }, 1000)
          }
        })
      }
    },
    // 安卓手机访问此网页时，需要userByAndroidToWeb函数实现自动登录。
    userByAndroidToWeb(params) {
      let user = JSON.parse(params)
      if(user != undefined){
        this.$refs.du.disabled = 'disabled'
        this.proxyDengLu = true
        this.$store.commit('loginUserChange', user)
        this.$store.commit('userNameChange', {id: user.userId, name: user.userMc})
        this.$nextTick(function () {
          if (this.$store.state.loginUser) {
            this.user.name = this.$store.state.loginUser.userDl
            this.user.pwd = this.$store.state.loginUser.userMm
            var _this = this
            setTimeout(function () {
              _this.$router.replace('/list')
            }, 1000)
          }
        })
      }
        return "js调用成功"
    }
  },
  mounted () {
    // 龚韬的APP调用方法
    window.addEventListener('message', this.wsFunc, false)
    
    // 安卓手机访问此网页时，需要userByAndroidToWeb函数实现自动登录。
    window.callJsFunction = this.userByAndroidToWeb
  },
  destroyed () {
    window.removeEventListener('message', this.wsFunc, false)
  }
}
</script>

<style lang="stylus" scoped>
  .login
    position:absolute
    height:100%
    width:100%
    left: 0
    top: 0
    right: 0
    bottom: 0
    display:flex
    flex-direction:column
    overflow:hidden
    justify-content:center
    align-items:center
    font-size:.4rem
    text-align:center
    background: url(../assets/imgs/beijing.jpg) no-repeat
    background-size: 100% 100%
    .login-container
      .username
        display:flex
        align-items:center
        .username-title
          width:30%
        .username-input
          .username-input-title
            padding-left:.1rem
            border-radius:.1rem
            border:1px solid #25A4BB
      .userpassworld
        margin:.3rem 0
        display:flex
        align-items:center
        .userpassworld-title
          width:30%
        .userpassworld-input
          .userpassworld-input-title
            padding-left:.1rem
            border-radius:.1rem
            border:1px solid #25A4BB
      .userbutton
        .userbutton-btn
          background: #00bcd4
          padding:0 .3rem
          border-radius:.1rem
      .customSpinner >>> .mint-spinner-fading-circle
        position: absolute
        top: 45%
        left: 46%
        z-index: 10
  .warningInfo
    color: red

</style>



// WEBPACK FOOTER //
// src/login/Login.vue